import type { Nullish } from '@iheartjane/types';

export const PROMPTS = {
  bankLinking: '__jane_bloom_bank_linking_prompt',
  /** Holds the product IDs the Leave Review prompt was dismissed for. */
  leaveReview: '__jane_bloom_leave_review_prompt',
  login: '__jane_bloom_login_prompt',
};

export type PromptsType = (typeof PROMPTS)[keyof typeof PROMPTS];

export const getPromptCookieName = (
  prompt: PromptsType,
  cookiePrefix: Nullish<string>
): string => `${cookiePrefix ?? ''}${prompt}`;
